import { useAuth0 } from "@auth0/auth0-react";
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import useCountDown from 'react-countdown-hook';
import { connect, useSelector } from "react-redux";
import {
    HashRouter, NavLink, Redirect, Route, Switch, BrowserRouter
} from "react-router-dom";
import LogoutButton from "./Auth/LogoutButton";
import ConversationLogs from "./Components/ConversationWidget/ConversationLogs";
import { API_URL } from './ConstVariable';
import Logo from "./Logo/Logo";
import "./Menubar.css";
import useFetchData from "./Middleware/useFetchData";
import BPBrokerHealth from "./Pages/BPBrokerHealth";
import Callhistory from "./Pages/Callhistory";
import DirectCall from "./Pages/DirectCall";
import ManualOrderContainer from "./Pages/ManualOrderContainer";
import Redirecting from "./Pages/Redirecting";
import Session from "./Pages/Session";
import Stats from "./Pages/Stats";
import Trashcall from "./Pages/Trashcall";
import Workdesk from "./Pages/Workdesk";
import {
    clearCenterNameFunc, clearConversationIdFunc, ClearError, setAssignedCenterList, setDataFetchingStatus,
    SetError, UserName, setCustomersDetails, setDirectCallStaticData, setScanList
} from "./redux-store/actions";
import ConnectionManager from "./WebSocketService/ConnectionManager";
import { GET_CUSTOMER_LIST, GET_DIRECT_CALL_INFO } from "./utils/endPoints";
import SessionExpired from "./Pages/SessionExpired";
import ConversationTranscript from "./Pages/ConversationTranscript";

//className Menubar extends Component {
const Menubar = (props) => {

    const errorHandler = (data) => {
        console.log(data)
    }
    const { loading, data, error } = useFetchData(GET_DIRECT_CALL_INFO, errorHandler);
    const {
        loading: customer_loading,
        data: customerList,
        error: customer_error,
    } = useFetchData(GET_CUSTOMER_LIST, errorHandler);

    useEffect(() => {
        if (data) {
            props.setDirectCallStaticData(data?.data)
        }

    }, [data])
    useEffect(() => {
        if (customerList) {
            props.setCustomersDetails(customerList?.data)
        }

    }, [customerList])

    const nw_status = props.get_error_code()
    const number_of_new_calls_since_last_search = props.number_of_new_calls_since_last_search;
    const initialTime = 30 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const { getAccessTokenSilently } = useAuth0();

    const GetAuthToken = async () => {
        const token = await getAccessTokenSilently();
        return token;
    };

    const [timeLeft, { start, pause, resume, reset }] = useCountDown(initialTime, interval);
    // To Get the operator center assigned list
    const getCenterList = async () => {
        const token = await GetAuthToken();

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            credentials: "include",
            // body: raw,
            redirect: "follow",
        };
        let GET_ASSIGNED_CENTER = `${API_URL}/oi/api/v2/GetAssignedCenters`;

        fetch(`${GET_ASSIGNED_CENTER}`, requestOptions)
            .then((response) => {
                // console.log("resposne", response);
                if (response.status >= 400) {
                    props.SetErrorForDisplay({
                        severity: "warning",
                        message: "Failed to fetch the center List",
                    });

                    return;
                }

                return response.json();
            })
            .then((data) => {
                if (data.length > 0) {
                    let filterCenterList = data.map((item) => {
                        return {
                            display_name: item.display_name,
                            id: item.id,
                            center_name: item.display_name,
                            center_id: item.metadata?.center_id,
                            center_prefix: item.metadata?.center_prefix,
                            conversation_workflow: item?.conversation_workflow

                        };
                    });

                    props.AssignedCenterList(filterCenterList)



                }
            })
            .catch((error) => {
                props.SetErrorForDisplay({
                    severity: "warning",
                    message: "Failed to fetch the center List",
                });
                console.log("Error", error);
            });
    };
    const getScanList = async () => {
        const token = await GetAuthToken();

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: raw,
            redirect: "follow",
            credentials: "include"
        };
        let GET_SCAN_LIST = `${API_URL}/oi/api/v2/get-scan-list`;

        fetch(`${GET_SCAN_LIST}`, requestOptions)
            .then((response) => {
                // console.log("resposne", response);
                if (response.status >= 400) {
                    props.SetErrorForDisplay({
                        severity: "warning",
                        message: "Failed to fetch the scan List",
                    });

                    return;
                }

                return response.json();
            })
            .then((response) => {
                const {data,error_description,error_code}=response 
                if (data.length > 0) {
                    props.setScanList(data)
                }
            })
            .catch((error) => {
                props.SetErrorForDisplay({
                    severity: "warning",
                    message: "Failed to fetch the scan List",
                });
                console.log("Error", error);
            });
    };
    const directCallRelatedInfo = () => {


    }

    const closeNewCallAlert = () => {
        props.reset_number_of_new_calls_since_last_search()
    }
    const { willTryToReconnectWebSocketInSec, WebSocketConnectionState } =
        useSelector((state) => state);



    const [count, setCount] = useState(0);
    const [oldCount, setOldCount] = useState(-1)

    useEffect(() => {
        if (timeLeft === 0 && props.startInternetConnectTime) {
            const newTime = 30 * 1000;
            start(newTime);
        }

    }, [timeLeft, props.startInternetConnectTime])
    useEffect(() => {

        if (props.timesTryToconnect === 2 && props.startInternetConnectTime) {
            start() // Starting a internet connection timer
        }
    }, [props.timesTryToconnect])






    useEffect(async () => {
        let Token = await GetAuthToken();
        // console.log("Token")
        localStorage.MyToken = Token;
        getCenterList()
        // getScanList()
    }, []);
    let location = window.location;
    useEffect(() => {
        if (location.hash === "#/callhistory") {
            addActiveforCallHistory();
        } else if (location.hash === "#/trash_call") {
            addActiveforTrash();
        } else if (location.hash === "#/stats") {
            addActiveforStats();
        } else if (location.hash === "#/manual_order") {
            addActiveforManualOrder();
        } else if (location.hash.includes("logs")) {

        }
        else if (location.hash === "#/workdesk") {
            addActiveforWorkdesk();
        } else if (location.hash === '#/direct_call') {
            addActiveDirectCall()
        }

        props.setUserNameToredux({ name: user.nickname, email: user.email });
    }, []);

    // let location = useLocation();
    // const [timeStatus, setTimeStatus] = useState(true);

    // useEffect(() => {
    //   setTimeStatus(true);
    // }, [props.errorForDisplay]);

    const addActiveforWorkdesk = () => {
        props.clearConversationIdFunc();
        props.clearCenterNameFunc();
        props.setDataFetchingStatus(false);
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        }
        else {
            var element1 = document.getElementById("li_workdesk");
            element1?.classList.add("active");

            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
            var element3 = document.getElementById("li_trash");
            element3?.classList.remove("active");
            var element4 = document.getElementById("li_stats");
            element4?.classList.remove("active");
            var element5 = document.getElementById("li_manualOrder");
            element5?.classList.remove("active");


            var element6 = document.getElementById("li_directCall");
            element6?.classList.remove("active");
        }
    };
    //NOTE:- to active the callhistory tab 
    const addActiveforCallHistory = () => {
        props.clearConversationIdFunc();
        props.clearCenterNameFunc();
        props.setDataFetchingStatus(false);
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        }
        else {
            var element1 = document.getElementById("li_callhistory");
            element1?.classList.add("active");

            var element2 = document.getElementById("li_workdesk");
            element2?.classList.remove("active");
            var element3 = document.getElementById("li_trash");
            element3?.classList.remove("active");
            var element4 = document.getElementById("li_stats");
            element4?.classList.remove("active");
            var element5 = document.getElementById("li_manualOrder");
            element5?.classList.remove("active");

            var element6 = document.getElementById("li_directCall");
            element6?.classList.remove("active");
        }
    };

    //NOTE:- to active the Trash tab 
    const addActiveforTrash = () => {
        props.clearConversationIdFunc();
        props.clearCenterNameFunc();
        props.setDataFetchingStatus(false);
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        } else {
            var element1 = document.getElementById("li_trash");
            element1?.classList.add("active");

            var element2 = document.getElementById("li_workdesk");
            element2?.classList.remove("active");
            var element3 = document.getElementById("li_callhistory");
            element3?.classList.remove("active");
            var element4 = document.getElementById("li_stats");
            element4?.classList.remove("active");
            var element5 = document.getElementById("li_manualOrder");
            element5?.classList.remove("active");

            var element6 = document.getElementById("li_directCall");
            element6?.classList.remove("active");
        }
    };

    //NOTE: To active the stats tab 
    const addActiveforStats = () => {
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        } else {
            var element1 = document.getElementById("li_stats");
            element1?.classList.add("active");

            var element2 = document.getElementById("li_workdesk");
            element2?.classList.remove("active");
            var element3 = document.getElementById("li_callhistory");
            element3?.classList.remove("active");
            var element4 = document.getElementById("li_trash");
            element4?.classList.remove("active");
            var element5 = document.getElementById("li_manualOrder");
            element5?.classList.remove("active");

            var element6 = document.getElementById("li_directCall");
            element6?.classList.remove("active");
        }
    };

    //NOTE:- to active the manualOrder tab 
    const addActiveforManualOrder = () => {
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        } else {
            var element1 = document.getElementById("li_manualOrder");
            element1?.classList.add("active");

            var element2 = document.getElementById("li_workdesk");
            element2?.classList.remove("active");
            var element3 = document.getElementById("li_callhistory");
            element3?.classList.remove("active");
            var element4 = document.getElementById("li_trash");
            element4?.classList.remove("active");
            var element5 = document.getElementById("li_stats");
            element5?.classList.remove("active");


            var element6 = document.getElementById("li_directCall");
            element6?.classList.remove("active");
        }
    };

    const addActiveDirectCall = () => {
        if (user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer") {
            var element2 = document.getElementById("li_callhistory");
            element2?.classList.remove("active");
        }else{
        var element1 = document.getElementById("li_directCall");
        element1.classList.add("active");



        var element2 = document.getElementById("li_workdesk");
        element2?.classList.remove("active");
        var element3 = document.getElementById("li_callhistory");
        element3?.classList.remove("active");
        var element4 = document.getElementById("li_trash");
        element4?.classList.remove("active");
        var element5 = document.getElementById("li_stats");
        element5?.classList.remove("active");
        var element6 = document.getElementById("li_manualOrder");
        element6?.classList.remove("active");
        }

    }

    // const modal = {
    //   hidden: {
    //     y: "-100vh",
    //     opacity: 0,
    //   },
    //   visible: {
    //     y: "300px",
    //     opacity: 1,
    //     transition: { type: "spring", delay: 0.5 },
    //   },
    // };
    const errorBar = () => {
        // setTimeout(() => {
        //   setTimeStatus(false);
        //   props.ClearErrorForDisplay();
        // }, 4000);
        if (
            props != null &&
            props.errorForDisplay != null &&
            props.errorForDisplay.message.length > 0
        ) {
            // setTimeStatus(() => true);

            return (
                <div>
                    <AnimatePresence>
                        <motion.div
                            className="align-items-center"
                            // variants={modal}
                            initial={{ y: -250 }}
                            animate={{ y: 2 }}
                            transition={{ delay: 0.2 }}
                        >
                            {/* <h1>Save</h1> */}
                            <Alert
                                onClick={() => props.ClearErrorForDisplay()}
                                variant={props.errorForDisplay.severity}
                                dismissible
                                onClose={() => props.ClearErrorForDisplay()}
                            >
                                <Alert.Heading>{props.errorForDisplay.severity}</Alert.Heading>
                                {props.errorForDisplay.message.map((item) => {
                                    return <p>{item}</p>;
                                })}
                            </Alert>
                        </motion.div>
                    </AnimatePresence>
                </div>
            );
        }
        // return;
    };

    const { user } = useAuth0();
    const user_profile = user?.oi_profile?.toLowerCase();

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            setCount((oldCount) => oldCount + 1)
            setOldCount(count)
            // Render a completed state
            return "";
        } else {
            // Render a countdown
            return <span>{seconds} sec</span>;
        }
    };


    const reloadWindow = () => {
        window.location.reload()
    }
    // console.log("__WebSocketConnectionState",WebSocketConnectionState)
    return (
        <BrowserRouter>
            { ( window.location.toString().includes("/logs") === false && window.location.toString().includes("/health") === false  && window.location.toString().includes("/expired") === false) &&
                <header className="topbar-nav" id="menu-bar" style={{display:"block"}}>
                    <div style={{ position: "absolute", zIndex: "1000", width: "100%" }}>
                        {props.errorForDisplay && errorBar()}
                    </div>
                    <nav className="navbar navbar-expand">
                        <ul className="navbar-nav mr-auto align-items-center">
                            <li className="nav-item">
                                <a className="nav-link" href="javascript:void();">
                                    <div className="media align-items-center">
                                        <Logo />
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <ul className="horizontal-menu" style={{ display:user_profile == "demo" ?"none": "flex" }}>
                                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                                        <>
                                            <li
                                                onClick={() => addActiveforWorkdesk()}
                                                id="li_workdesk"
                                                style={{ display: "flex" }}
                                            >
                                                <NavLink to="/workdesk">
                                                    <i
                                                        className="zmdi zmdi-view-dashboard"
                                                        aria-hidden="true"
                                                    ></i>
                                                    <span className="title">Work Desk</span>
                                                </NavLink>
                                            </li>

                                        </>}
                                    <li
                                        onClick={() => addActiveforCallHistory()}
                                        id="li_callhistory"
                                        style={{ display: "flex", visibility: user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer" ? "collapse" : "visible" }}
                                    >
                                        <NavLink to="/callhistory">
                                            <i className="zmdi zmdi-layers"></i>
                                            <span className="title">Call History</span>
                                        </NavLink>
                                    </li>
                                    {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" &&
                                        <>
                                            <li
                                                onClick={() => addActiveforTrash()}
                                                id="li_trash"
                                                style={{ display: "flex" }}
                                            >
                                                <NavLink to="/trash_call">
                                                    <i className="zmdi zmdi-delete"></i>
                                                    <span className="title">Test Call</span>
                                                </NavLink>
                                            </li>

                                            <li
                                                onClick={() => addActiveforManualOrder()}
                                                id="li_manualOrder"
                                                style={{ display: "flex" }}>
                                                <NavLink to="/manual_order">
                                                    <i className="zmdi  zmdi-account"></i>
                                                    <span className="title">Manual Order</span>
                                                </NavLink>
                                            </li>
                                            <li
                                                onClick={() => addActiveDirectCall()}
                                                id="li_directCall"
                                                style={{ display: "flex" }}
                                            >
                                                <NavLink to="/direct_call">
                                                    <i className="zmdi  zmdi-account"></i>
                                                    <span className="title">Direct Call</span>
                                                </NavLink>
                                            </li>
                                            {user?.can_access_stats_page && <li
                                                onClick={() => addActiveforStats()}
                                                id="li_stats"
                                                style={{ display: "flex" }}
                                            >
                                                <NavLink to="/stats">
                                                    <i className="zmdi zmdi-assignment-account"></i>
                                                    <span className="title">Stats</span>
                                                </NavLink>
                                            </li>}
                                        </>
                                    }
                                </ul>
                            </li>
                        </ul>
                        <ul className="navbar-nav align-items-center right-nav-link">
                            <li className="nav-item">
                                {(props.is_Any_Datafetching_Request_InProgress && !props.isReferralFormFetching) ?
                                    <p
                                        style={{
                                            fontSize: "18px",
                                            // fontWeight: "600",
                                            marginRight: "50px",
                                            background: "yellow",
                                            // border: "1px solid",
                                            padding: "5px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        Please wait data is loading......
                                    </p>
                                    : (props.is_Any_Datafetching_Request_InProgress || props.isReferralFormFetching) && <p
                                        style={{
                                            fontSize: "18px",
                                            // fontWeight: "600",
                                            marginRight: "50px",
                                            background: "yellow",
                                            // border: "1px solid",
                                            padding: "5px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        Please wait referral form and data is loading......
                                    </p>
                                }


                            </li>
                        </ul>
                        <ul className="navbar-nav align-items-center right-nav-link">
                            <li className="nav-item">
                                {number_of_new_calls_since_last_search > 0 && <p className="menubar__newcallsindicator">New Calls!<a onClick={closeNewCallAlert} class="ico-times" role="img" aria-label="Cancel"></a></p>}
                            </li>
                        </ul>
                        <ul className="navbar-nav align-items-center right-nav-link">
                            <li className="nav-item">
                                {
                                    (!nw_status.error_code) && <p className="menubar__websocketConnected">Connected <span className="circle"></span></p>
                                }
                                {
                                    (nw_status.error_code === "E001" || nw_status.error_code === "E002") && <p className="menubar__websocketReconnect">{nw_status.error_code} - {nw_status.description}</p>
                                }
                                {
                                    (nw_status.error_code === "I999" || nw_status.error_code === "I001") && <p className="menubar__websocketConnected">{nw_status.description} <span className="circle-orange"></span></p>
                                }

                            </li>
                        </ul>
                        <ul className="navbar-nav align-items-center right-nav-link">
                            <li className="nav-item">Welcome&nbsp;{user.name} </li>
                        </ul>
                        &nbsp;&nbsp;
                        <IconButton onClick={reloadWindow}>
                            <RefreshIcon />
                        </IconButton>
                        <LogoutButton /> &nbsp;&nbsp;
                    </nav>
                </header>
            }

            {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && user_profile!="demo" &&
                <Switch>
                    <Route exact path="/workdesk" render={(prop) => (<Workdesk  {...props} />)} />
                    <Route exact path="/callhistory" render={(prop) => (<Callhistory  {...props} />)} />
                    <Route exact path="/trash_call" render={(prop) => (<Trashcall  {...props} />)} />
                    <Route exact path="/manual_order" render={(prop) => (<ManualOrderContainer {...props} />)} />
                    <Route exact path="/stats" render={(prop) => (<Stats {...props} />)} />
                    <Route exact path="/direct_call" render={(prop) => (<DirectCall  {...props} />)} />
                    <Route exact path="/logs/:conversation_id" component={ConversationLogs}></Route>
                    <Route exact path="/health/bp-broker/:center_prefix" component={BPBrokerHealth}></Route>
                    <Route path="/redirect" render={(prop) => (<Redirecting  {...props} ></Redirecting>)}></Route>
                    <Route path="/continue-call/:conversation_id" render={(prop) => (<ManualOrderContainer  {...props} ></ManualOrderContainer>)}></Route>

                    <Route path="/">

                        <Redirect to="/workdesk" />
                    </Route>
                </Switch>
            }
            {user_profile === "demo" &&
                <Switch>
                    <Route exact path="/" render={(prop) => (<ConversationTranscript  {...props} />)} />
                    <Route path="/">
                        <Redirect to="/" />
                    </Route>
                </Switch>
            }
            {user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer" &&
                <Switch>
                    <Route exact path="/callhistory" render={(prop) => (<Callhistory  {...props} />)} />
                    <Route path="/">
                        <Redirect to="/callhistory" />
                    </Route>
                </Switch>
            }
        </BrowserRouter>
    );
};


const mapStateToProps = (state) => {
    return {
        errorForDisplay: state.Error,
        selectedConversationId: state.SelectedConversationId,
        is_Any_Datafetching_Request_InProgress:
            state.is_Any_Datafetching_Request_InProgress,
        isReferralFormFetching: state.isReferralFormFetching,
        isInternetDisconnected: state.isInternetDisconnected,
        timesTryToReconnectInternet: state.timesTryToReconnectInternet
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ClearErrorForDisplay: () => dispatch(ClearError()),
        setUserNameToredux: (val) => dispatch(UserName(val)),
        clearConversationIdFunc: () => dispatch(clearConversationIdFunc()),
        clearCenterNameFunc: () => dispatch(clearCenterNameFunc()),
        setDataFetchingStatus: (val) => dispatch(setDataFetchingStatus(val)),
        SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
        setDirectCallStaticData: (payload) => dispatch(setDirectCallStaticData(payload)),
        setCustomersDetails: (payload) => dispatch(setCustomersDetails(payload)),

        AssignedCenterList: (centers) =>
            dispatch(setAssignedCenterList(centers)),
        setScanList: (payload) =>
        dispatch(setScanList(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ConnectionManager(Menubar));
